import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Subject } from 'rxjs';
import { datadogRum } from '@datadog/browser-rum';

export class GlobalEventDistributor {

    constructor() {
        this.emitter$ = new BehaviorSubject('');
        this.busEvents$ = new Subject();
        this.globalObj = {};
        const host = window.location.host;

        if (!host.includes('localhost')) {
            datadogRum.init({
                applicationId: '{{datadog-appId}}',
                clientToken: '{{datadog-clientToken}}',
                site: 'datadoghq.eu',
                service: '{{datadog-service}}',
                version: '1.0.1',
                sampleRate: 100,
                trackInteractions: true,
                defaultPrivacyLevel: 'mask-user-input'
            });
        }
    }

    /**
     * Set key & value in global object and emit event when msg exist
     * @param {*} obj - Key & Value object
     * @param {*} msg - Publish msg
     */
    setData_Old(obj, msg = '') {
        for (const key of Object.keys(obj)) {
            this.globalObj[key] = obj[key];
        }

        if (msg) {
            this.emitter$.next(msg);
        }
    }

    /**
     * Get value by passign key
     * @param {*} key - Key to fetch value
     */
    getData_Old(key) {
        return this.globalObj[key];
    }

    setData(key, value) {
        this.globalObj[key] = value;
        this.emitter$.next({ ...this.globalObj, "name": key, value });
    }

    getData(key) {
        return this.globalObj[key];
    }

    /**
     * Trigger subject from source
     * @param {*} eventName - Event name
     * @param {*} arg - argument / value
     */
    triggerBusEvent(eventName, value) {
        this.busEvents$.next({ "name": eventName, value });
    }
}

window.globalEventDistributor = new GlobalEventDistributor();
